/* CarbonTree tap-speed sampler (15 Oct 2026). Runs on phones, on product pages and the home page,
   until 24 Oct 2026, then does nothing. It adds no tap or click listeners: it only reads the tap
   timings the browser already keeps (Event Timing) and, on Chrome/Android, which scripts were busy
   (Long Animation Frames). When the page is hidden it sends that page view's slowest tap in one small
   message. Nothing personal is sent: no cookies, no customer, no typed text. */
(function () {
  'use strict';
  var STOP = Date.UTC(2026, 9, 23, 18, 30); // 24 Oct 2026, 00:00 IST
  var TO = 'https://mail.carbontree.com/v';
  var V = 1;
  try {
    var PO = window.PerformanceObserver, types = PO && PO.supportedEntryTypes;
    var ua = navigator.userAgent || '';
    if (Date.now() > STOP || !types || types.indexOf('event') < 0 || !navigator.sendBeacon) return;
    if (!/Mobi|iPhone|iPod|Android/.test(ua)) return; // phones only

    var r = Math.round;
    var groups = {}, worstId = 0, worstDur = -1, seen = 0, loafs = [];
    var viewId = newId(), sentDur = -1, sentSeen = 0, restoredAt = 0;
    var countBase = performance.interactionCount || 0;

    function newId() { return (Math.random().toString(36).slice(2, 12) + Date.now().toString(36)).replace(/[^a-z0-9]/g, ''); }

    function onEvents(list) {
      var es = list.getEntries();
      for (var i = 0; i < es.length; i++) {
        var e = es[i], id = e.interactionId;
        if (!id || e.startTime < restoredAt) continue;
        var g = groups[id];
        if (!g) { g = groups[id] = { d: 0, es: [] }; seen++; }
        if (g.es.length < 8) g.es.push(e);
        if (e.duration > g.d) g.d = e.duration;
        if (g.d > worstDur) { worstDur = g.d; worstId = id; }
      }
      // keep the slowest tap and the latest few (a tap's entries can arrive in two batches)
      var ids = Object.keys(groups);
      if (ids.length > 30) {
        ids.sort(function (a, b) { return b - a; });
        for (var j = 10; j < ids.length; j++) if (+ids[j] !== +worstId) delete groups[ids[j]];
      }
    }

    function onFrames(list) {
      var es = list.getEntries();
      for (var i = 0; i < es.length; i++) loafs.push(es[i]);
      if (loafs.length > 80) {
        var w = window_();
        loafs = loafs.filter(function (l, k) { return k >= loafs.length - 40 || (w && overlaps(l, w)); });
      }
    }

    // the slowest tap's frame: when it started, when its code ended, when the screen was drawn
    function window_() {
      var g = groups[worstId];
      if (!g) return null;
      var es = g.es.slice().sort(function (a, b) { return a.startTime - b.startTime; });
      var big = es[0];
      for (var i = 1; i < es.length; i++) if (es[i].duration > big.duration) big = es[i];
      var paintAt = big.startTime + big.duration;
      var frame = es.filter(function (e) { return Math.abs(e.startTime + e.duration - paintAt) <= 8; });
      var first = frame[0] || big, codeEnd = 0;
      for (var k = 0; k < frame.length; k++) codeEnd = Math.max(codeEnd, frame[k].processingEnd);
      return { big: big, first: first, from: first.startTime, codeEnd: codeEnd || big.processingEnd, paintAt: paintAt };
    }
    function overlaps(l, w) { return l.startTime <= w.paintAt && l.startTime + l.duration >= w.from; }

    function src(u) {
      if (!u) return '';
      var m = String(u).split(/[?#]/)[0].match(/^https?:[/][/]([^/]+)(.*)$/);
      if (!m) return String(u).slice(0, 120);
      var parts = m[2].split('/').filter(Boolean);
      return (m[1] + '/' + parts.slice(-2).join('/')).slice(0, 120);
    }

    function sel(el) {
      var out = [];
      for (var i = 0; el && el.tagName && i < 3; i++, el = el.parentElement) {
        var s = el.tagName.toLowerCase();
        if (el.id) s += '#' + el.id;
        else {
          var c = (typeof el.className === 'string' ? el.className : '').trim().split(/\s+/).filter(Boolean).slice(0, 2);
          if (c.length) s += '.' + c.join('.');
        }
        out.unshift(s);
        if (el.id) break;
      }
      return out.join('>').slice(0, 160);
    }

    // the words on a tapped button or link ('Add to cart', 'M'); never anything typed into a box
    function words(el) {
      var b = el && el.closest && el.closest('button,a,label,summary,[role=button],[role=tab],li');
      if (!b || b.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)) return '';
      var t = (b.textContent || '').replace(/\s+/g, ' ').trim();
      return /@|[0-9]{6,}/.test(t) ? '' : t.slice(0, 40);
    }

    function loadState(t) {
      if (restoredAt) return 'bfcache';
      var n = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (!n) return '';
      if (t < n.domInteractive) return 'loading';
      if (!n.domContentLoadedEventEnd || t < n.domContentLoadedEventEnd) return 'dom-interactive';
      if (!n.loadEventEnd || t < n.loadEventEnd) return 'dom-content-loaded';
      return 'complete';
    }

    var os = /iPhone|iPad|iPod/.test(ua) ? 'ios' : /Android/.test(ua) ? 'android' : 'other';
    var osv = ((os === 'ios' ? ua.match(/OS ([0-9]+)_/) : ua.match(/Android ([0-9]+)/)) || [])[1];
    var app = /Instagram/.test(ua) ? 'instagram' : /FBAN|FBAV|FB_IAB|FBIOS|FB4A/.test(ua) ? 'facebook'
      : /Snapchat/.test(ua) ? 'snapchat' : /GSA[/]/.test(ua) ? 'google-app' : /LinkedInApp/.test(ua) ? 'linkedin'
      : (/; wv[)]/.test(ua) || (os === 'ios' && !/Safari[/]/.test(ua))) ? 'other-app' : '';
    var br = /SamsungBrowser/.test(ua) ? 'samsung' : /CriOS|Chrome[/]/.test(ua) ? 'chrome' : (os === 'ios' && /Safari[/]/.test(ua)) ? 'safari' : 'other';
    var brv = (ua.match(/(?:SamsungBrowser|CriOS|Chrome)[/]([0-9]+)/) || ua.match(/Version[/]([0-9]+)/) || [])[1];
    var q = location.search;
    var ad = /[?&]fbclid=/.test(q) ? 'meta' : /[?&](gclid|gbraid|wbraid)=/.test(q) ? 'google'
      : (q.match(/[?&]utm_source=([^&]{1,20})/) ? 'utm:' + decodeURIComponent(q.match(/[?&]utm_source=([^&]{1,20})/)[1]).toLowerCase() : '');
    var ref = '';
    try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
    if (/carbontree/.test(ref)) ref = '';
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var navType = nav && nav.type || '';

    function body() {
      var w = window_();
      if (!w) return null;
      var scripts = [], sm = 0, lm = 0;
      for (var i = 0; i < loafs.length; i++) {
        var l = loafs[i];
        if (!overlaps(l, w)) continue;
        if (l.styleAndLayoutStart) lm += l.startTime + l.duration - l.styleAndLayoutStart;
        for (var j = 0; l.scripts && j < l.scripts.length; j++) { sm += l.scripts[j].duration; scripts.push(l.scripts[j]); }
      }
      scripts.sort(function (a, b) { return b.duration - a.duration; });
      var c = navigator.connection || {};
      var count = performance.interactionCount ? performance.interactionCount - countBase : seen;
      return {
        v: V, id: viewId, p: location.pathname, th: window.Shopify && Shopify.theme && Shopify.theme.id,
        d: r(w.big.duration), w: r(w.first.processingStart - w.first.startTime), pr: r(w.codeEnd - w.first.processingStart),
        pa: r(Math.max(0, w.paintAt - w.codeEnd)), e: w.big.name, t: sel(w.big.target || w.first.target),
        tx: words(w.big.target || w.first.target), at: r(w.from - restoredAt), ls: loadState(w.from), n: Math.max(count, seen),
        sc: scripts.slice(0, 3).map(function (s) {
          return { u: src(s.sourceURL), f: (s.sourceFunctionName || '').slice(0, 80), i: (s.invoker || '').slice(0, 120),
            it: s.invokerType || '', d: r(s.duration), fl: r(s.forcedStyleAndLayoutDuration || 0) };
        }),
        sm: loafs.length ? r(sm) : undefined, lm: loafs.length ? r(lm) : undefined,
        os: os, ov: osv ? +osv : undefined, br: br, bv: brv ? +brv : undefined, ia: app || undefined,
        mem: navigator.deviceMemory, cpu: navigator.hardwareConcurrency, net: c.effectiveType, sd: c.saveData,
        vw: innerWidth, dpr: window.devicePixelRatio, nt: restoredAt ? 'bfcache' : navType, ad: ad || undefined, ref: ref || undefined
      };
    }

    // the shopper's cookie choice: if analytics was declined, nothing is sent
    function consented() {
      try {
        var cp = window.Shopify && Shopify.customerPrivacy;
        if (cp && typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
      } catch (e) {}
      return true;
    }

    function send() {
      if (worstDur < 0 || (worstDur === sentDur && seen === sentSeen) || !consented()) return;
      try {
        var b = body();
        if (b && navigator.sendBeacon(TO, JSON.stringify(b))) { sentDur = worstDur; sentSeen = seen; }
      } catch (e) {}
    }

    addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') send(); }, true);
    addEventListener('pagehide', send, true);
    // back/forward cache: the page comes back as a new page view
    addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      groups = {}; worstId = 0; worstDur = -1; seen = 0; loafs = []; sentDur = -1; sentSeen = 0;
      viewId = newId(); restoredAt = ev.timeStamp; countBase = performance.interactionCount || 0;
    }, true);

    new PO(onEvents).observe({ type: 'event', buffered: true, durationThreshold: 16 });
    if (types.indexOf('long-animation-frame') >= 0) new PO(onFrames).observe({ type: 'long-animation-frame', buffered: true });
  } catch (e) {}
})();
